var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5703,
    y: 3.27026,
    width: 10.21,
    height: 16.68,
    fill: "#F26122"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6687 11.6102C13.6518 8.3637 15.1264 5.28922 17.6687 3.27017C13.3189 -0.15054 7.07064 0.346185 3.31599 4.41117C-0.438663 8.47616 -0.438663 14.7442 3.31599 18.8092C7.07064 22.8741 13.3189 23.3709 17.6687 19.9502C15.1264 17.9311 13.6518 14.8566 13.6687 11.6102Z",
    fill: "#EA1D25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.828 11.6101C34.8254 15.6694 32.5068 19.3715 28.8558 21.1459C25.2049 22.9203 20.8614 22.4561 17.668 19.9501C22.268 16.328 23.0646 9.66439 19.448 5.06009C18.9295 4.39336 18.3318 3.79227 17.668 3.27009C20.8614 0.764088 25.2049 0.299837 28.8558 2.07427C32.5068 3.8487 34.8254 7.55075 34.828 11.6101Z",
    fill: "#F69E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.d5119dfa3f25aa17b24e5f563ec2e250.svg";
export { ForwardRef as ReactComponent };